import { atom } from "jotai";

let userInfo = localStorage.getItem("userAdminInfo");
if (userInfo) {
    userInfo = JSON.parse(userInfo);
}

export const sidebarAtom = atom("ingredient");
export const userAtom = atom(userInfo || {});